import { createContext } from 'react';
import { LanguageContextData } from './interfaces/language-context-props.interface';

const LanguageContext = createContext<LanguageContextData>(
    {} as LanguageContextData,
);

export default LanguageContext;
